import { CalendarDays, LifeBuoy, Users } from "lucide-react";
import { motion, useInView } from "framer-motion";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { SPRING_BOUNCE } from "./animations";

const benefits = [
  { key: "choose", Icon: CalendarDays },
  { key: "community", Icon: Users },
  { key: "support", Icon: LifeBuoy },
];

const AdditionalBenefits = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section ref={sectionRef} className="tw-bg-white tw-px-6 tw-py-16 md:tw-px-12 md:tw-py-20">
      <div className="tw-mx-auto tw-max-w-6xl">
        <motion.h2
          className="tw-mb-10 tw-text-center tw-text-[26px] tw-font-extrabold md:tw-mb-12 md:tw-text-[32px]"
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
          transition={SPRING_BOUNCE}
        >
          {t("leader_programme.additional_benefits.title")}
        </motion.h2>

        <div className="tw-grid tw-gap-6 md:tw-grid-cols-3">
          {benefits.map(({ key, Icon }, index) => (
            <motion.article
              key={key}
              className="tw-flex tw-h-full tw-flex-col tw-items-center tw-rounded-3xl tw-bg-white tw-px-7 tw-py-10 tw-text-center tw-shadow-[0_6px_24px_rgba(0,0,0,0.09)]"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ ...SPRING_BOUNCE, delay: 0.1 + index * 0.1 }}
            >
              <Icon className="tw-mb-6 tw-h-16 tw-w-16 tw-stroke-[1.5] tw-text-primary-main" />
              <h3 className="tw-mb-3 tw-text-xl tw-font-extrabold">
                {t(`leader_programme.additional_benefits.items.${key}.title`)}
              </h3>
              <p className="tw-text-base tw-leading-relaxed tw-text-gray-600">
                {t(`leader_programme.additional_benefits.items.${key}.description`)}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdditionalBenefits;
